{
  "Accessibility Menu": "ప్రాప్యత మెనూ",
  "Reset settings": "సెట్టింగ్‌లను రీసెట్ చేయండి",
  "Close": "మూసివేయి",
  "Content Adjustments": "కంటెంట్ సర్దుబాట్లు",
  "Adjust Font Size": "ఫాంట్ పరిమాణాన్ని సర్దుబాటు చేయండి",
  "Highlight Title": "శీర్షికను హైలైట్ చేయండి",
  "Highlight Links": "లింక్‌లను హైలైట్ చేయండి",
  "Readable Font": "చదవడానికి అనుకూలమైన ఫాంట్",
  "Color Adjustments": "రంగు సర్దుబాట్లు",
  "Dark Contrast": "చీకటి వ్యత్యాసం",
  "Light Contrast": "తెల్లటి వ్యత్యాసం",
  "High Contrast": "అధిక వ్యత్యాసం",
  "High Saturation": "అధిక సంతృప్తి",
  "Low Saturation": "తక్కువ సంతృప్తి",
  "Monochrome": "మోనోక్రోమ్",
  "Tools": "పరికరాలు",
  "Reading Guide": "చదవడం మార్గదర్శకుడు",
  "Stop Animations": "యానిమేషన్‌లను ఆపు",
  "Big Cursor": "పెద్ద కర్సర్",
  "Increase Font Size": "ఫాంట్ పరిమాణాన్ని పెంచండి",
  "Decrease Font Size": "ఫాంట్ పరిమాణాన్ని తగ్గించండి",
  "Letter Spacing": "అక్షరాల మధ్య ఖాళీ",
  "Line Height": "లైన్ ఎత్తు",
  "Font Weight": "ఫాంట్ బరువు",
  "Dyslexia Font": "డిస్లెక్సియా ఫాంట్",
  "Language": "భాష",
  "Open Accessibility Menu": "ప్రాప్యత మెనూను తెరవండి",
  "Accessibility Profiles": "ప్రాప్యత ప్రొఫైళ్లు",
  "Seizure Safe Profile": "ఆప్యాయతా ప్రొఫైల్",
  "Stops animations and reduces color saturation.": "యానిమేషన్లు ఆపి రంగు సంతృప్తిని తగ్గిస్తుంది.",
  "Blind Profile": "మూఢుల కోసం ప్రొఫైల్",
  "Activates the screen reader for auditory navigation.": "ఆడియో మార్గదర్శకానికి స్క్రీన్ రీడర్‌ను సක්‍රීయం చేస్తుంది.",
  "Visually Impaired Profile": "దృష్టి లోపం ఉన్నవారికి ప్రొఫైల్",
  "Enhances contrast and readability for low vision.": "తక్కువ దృష్టి ఉన్నవారికి వ్యత్యాసం మరియు చదవగలిగేలా చేస్తుంది.",
  "ADHD Friendly Profile": "ADHD స్నేహపూర్వక ప్రొఫైల్",
  "Reduces distractions for better focus.": "మంచి దృష్టి కోసం భ్రమణాలను తగ్గిస్తుంది.",
  "Cognitive & Learning Profile": "జ్ఞాన మరియు అభ్యాస ప్రొఫైల్",
  "Helpful tools for reading and comprehension.": "చదవడం మరియు అర్థం చేసుకోవడానికి సహాయకరమైన సాధనాలు.",
  "Motor Impaired Profile": "మోటార్ లోపం ఉన్నవారికి ప్రొఫైల్",
  "Optimizes the site for keyboard-only navigation.": "కీవోర్డ్ మాత్రమే ఉపయోగించి నావిగేషన్ కోసం సైట్‌ను మెరుగుపరుస్తుంది.",
  "Headings": "శీర్షికలు",
  "Landmarks": "ల్యాండ్‌మార్క్‌లు",
  "Links": "లింక్‌లు",
  "Focus element": "ఫోకస్ అంశం",
  "Visit link": "లింక్ సందర్శించండి"
}